// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LearningUnitCategoryIcon_wrapper"};